<template>
	<div class="class-card" :class="{ open: isOpen }">
		<div class="container">
			<button
				class="row py-6 btn-reset"
				:aria-expanded="isOpen"
				:aria-controls="'collapse-' + classData.id"
				data-testid="class-card"
				@click="toggle"
			>
				<div class="col-lg-3 d-flex align-items-center justify-content-between">
					<div class="d-flex align-items-center justify-content-between">
						<span class="start-time h3">
							{{ classData.startTime }}
						</span>
						<span class="duration-desktop badge rounded-pill border px-2 ms-1 ms-xl-3">
							{{ classData.duration }}
						</span>
					</div>
					<span class="btn btn-simple align-self-start d-lg-none">
						<span v-if="isOpen"><MinusIcon :height="16" :width="16"></MinusIcon></span>
						<span v-else><PlusIcon :height="16" :width="16"></PlusIcon></span>
					</span>
				</div>
				<div class="col-lg-5 text-start">
					<h2 class="lead mb-0" role="heading" aria-level="2">{{ classData.name }}</h2>
					<h2 v-if="classData.leader" class="lead mb-0">w/ {{ classData.leader }}</h2>
				</div>
				<div class="col-lg-4 d-flex align-items-center justify-content-between mt-4 mt-lg-0 p-lg-0">
					<div>
						<span class="duration-mobile badge rounded-pill border px-2 me-2 mb-1">
							{{ classData.duration }}
						</span>
						<span
							v-if="classData.membershipAccess"
							class="badge rounded-pill border px-2 me-2 mb-1"
						>
							{{ classData.membershipAccess }}
						</span>
						<span v-if="classData.isPaidClass" class="badge rounded-pill border px-2 me-2 mb-1">
							{{ classData.isPaidClass }}
						</span>
					</div>
					<span class="btn btn-simple d-none d-lg-inline">
						<span v-if="isOpen"><MinusIcon :height="16" :width="16"></MinusIcon></span>
						<span v-else><PlusIcon :height="16" :width="16"></PlusIcon></span>
						<span class="visually-hidden">Toggle class details</span>
					</span>
				</div>
			</button>
			<BCollapse :id="'collapse-' + classData.id" v-model="isOpen">
				<div class="description">
					<div class="row">
						<div class="col-lg-6 offset-lg-3">
							<div class="description-main">{{ classData.description }}</div>
							<div>
								<span
									v-for="(tag, index) in classData.tags"
									:key="index"
									class="badge rounded-pill border px-2 me-2 mb-1"
								>
									{{ tag }}
								</span>
							</div>
						</div>
						<!-- <div class="col-lg-3 d-flex align-items-end justify-content-lg-end mt-3">
							<button class="btn btn-outline-dark" @click.stop="learnmore">Learn More</button>
						</div> -->
					</div>
				</div>
			</BCollapse>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { BCollapse } from 'bootstrap-vue-next';
import MinusIcon from '../icons/MinusIcon.vue';
import PlusIcon from '../icons/PlusIcon.vue';
import type { AempschedClass } from 'Types/aempsched/aempschedDay';

defineProps<{
	classData: AempschedClass;
}>();

const isOpen = ref(false);
const toggle = () => {
	isOpen.value = !isOpen.value;
};
// TODO: Post MVP Enhancement
// https://ltt.atlassian.net/browse/AEMPLAT-684
// const learnmore = () => {
// 	console.log('test');
// };
</script>

<style lang="scss" scoped>
$class-sched-border-color: rgba($border-color, 0.15);
.class-card {
	border-bottom: solid 1px $class-sched-border-color;
	transition: background-color 0.5s;

	.btn-reset {
		background-color: transparent;
		border: none;
		color: var(--kpl-body-color);
		margin-left: 0;
		margin-right: 0;
		width: 100%;
	}

	&.open {
		background-color: #e7e2d8;
	}

	&:hover {
		background-color: #e7e2d8;
	}

	.start-time {
		margin-bottom: map-get($spacers, 4);
		white-space: nowrap;

		@include media-breakpoint-up(lg) {
			margin-bottom: 0;
		}
	}

	.duration-desktop {
		display: none;

		@include media-breakpoint-up(lg) {
			display: inline-block;
		}
	}

	.duration-mobile {
		display: inline-block;

		@include media-breakpoint-up(lg) {
			display: none;
		}
	}

	.description {
		margin-bottom: map-get($spacers, 6);
		padding: map-get($spacers, 6) 0 map-get($spacers, 2);
		border-top: solid 1px $class-sched-border-color;

		&-main {
			margin-bottom: map-get($spacers, 8);
		}
	}
}
</style>
